/**
 * SectionStyles — global per-section style injector.
 *
 * Thin wrapper over `buildSectionCss` (src/lib/responsiveCss.js): reads
 * `content.responsive.{desktop|mobile}` and emits a scoped <style> tag with
 * CSS that targets `[data-section-key="X"] [data-el="Y"]` elements, section
 * spacing, and image position/zoom overrides. See responsiveCss.js for the
 * full schema.
 */
import { buildSectionCss } from "@/lib/responsiveCss";

export default function SectionStyles({ scopeKey, content }) {
  const css = buildSectionCss(scopeKey, content?.responsive || {});
  if (!css) return null;
  return <style dangerouslySetInnerHTML={{ __html: css }} data-section-styles={scopeKey} />;
}
